import type { ReactNode } from 'react';

import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { useContracts } from '@/hooks/api/use-contracts';

export interface GetContractsProps {
    children?: ReactNode;
}

/** N'affiche son contenu qu'une fois les contrats de l'utilisateur chargés (ou en échec). */
const GetContracts = (props: GetContractsProps) => {
    const { children } = props;
    const contracts = useContracts();

    if (contracts.isPending) return <SmallSpinner />;

    return <div>{children}</div>;
};

export default GetContracts;
